<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}

</script>

<style>
html,
body,
#app {
  height: 100%;
  margin: 0 auto;
  overflow: hidden;
}
/* 当前页面的最外部div */
/* body {
  filter: progid:DXImageTransform.Microsoft.BasicImage(graysale=1);
  -webkit-filter: grayscale(100%);
} */
</style>



// WEBPACK FOOTER //
// src/App.vue